import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
import HeaderSearch from './HeaderSearch';
import HeaderNotice from './HeaderNotice';
import HeaderAvatar from './HeaderAvatar';
import IMenu from '@/components/menu/menu';
import { mapState, mapMutations } from 'vuex';
export default {
  name: 'AdminHeader',
  components: {
    IMenu: IMenu,
    HeaderAvatar: HeaderAvatar,
    HeaderNotice: HeaderNotice,
    HeaderSearch: HeaderSearch
  },
  props: ['collapsed', 'menuData'],
  data: function data() {
    return {
      langList: [{
        key: 'CN',
        name: '简体中文',
        alias: '简体'
      },
      // {key: 'HK', name: '繁體中文', alias: '繁體'},
      // {key: 'US', name: 'English', alias: 'English'},
      {
        key: 'JP',
        name: '日本語',
        alias: '日本語'
      }],
      searchActive: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('setting', ['theme', 'isMobile', 'layout', 'systemName', 'lang', 'pageWidth'])), {}, {
    headerTheme: function headerTheme() {
      if (this.layout == 'side' && this.theme.mode == 'dark' && !this.isMobile) {
        return 'light';
      }
      return this.theme.mode;
    },
    langAlias: function langAlias() {
      var _this = this;
      var lang = this.langList.find(function (item) {
        return item.key == _this.lang;
      });
      return lang.alias;
    },
    menuWidth: function menuWidth() {
      var layout = this.layout,
        searchActive = this.searchActive;
      var headWidth = layout === 'head' ? '100% - 188px' : '100%';
      var extraWidth = searchActive ? '600px' : '400px';
      return "calc(".concat(headWidth, " - ").concat(extraWidth, ")");
    }
  }),
  methods: _objectSpread({
    callEditPwd: function callEditPwd() {
      this.$emit("showEditPwd");
    },
    toggleCollapse: function toggleCollapse() {
      this.$emit('toggleCollapse');
    },
    onSelect: function onSelect(obj) {
      this.$emit('menuSelect', obj);
    }
  }, mapMutations('setting', ['setLang']))
};